module.exports = __webpack_public_path__ + "static/media/analytics.6a2fdd96.svg";